;(function() {
  'use strict'

  angular.module('core.surveyTemplateCard', [])
})()
